/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import * as moment from 'moment';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ReportExecutionResource} from '../../components/api/resources/resource/execution-resources/report-execution.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-report-route-page',
  template: `
    <adn-report-list-page
      *ngIf="list"
      [list]="list">
    </adn-report-list-page>
  `
})
export class ReportRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ReportExecutionResource) private readonly ReportExecution: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.runReports.apiKey);

    this.adnListHelper.setUpList(this.list, this.ReportExecution, readOnly, 'fullReportExecutionList', {
      baseTable: 'reportExecution',
      getDefaultOrderByParam: () => 'DESCexecutionStartTime',
      nullsAsOldestParams: ['executionStartTime'],
      afterFill: (items: any[]) => {
        items.forEach((item: any) => {
          item.execTime = moment(item.executionEndTime).diff(moment(item.executionStartTime), 'seconds');
        });
      }
    });
  }
}
